import http from '@/services/http';
import {Company, CompanyFilters} from "@/interfaces/company.interface";
import {VuetifyPaginationInterface} from "@/interfaces/vuetify-pagination.interface";

export default {
    async getAll(pagination: VuetifyPaginationInterface, filters: CompanyFilters) {
        const response = await http.get(`/companies?page=${pagination.page}&itemsPerPage=${pagination.itemsPerPage}&search=${filters.search}`);
        return response.data;
    },
    async search(searchTerm: string) {
        const response = await http.get(`/companies/search/${searchTerm}`);
        return response.data;
    },
    async create(company: Company) {
        const response = await http.post(`/companies`, company);
        return response.data;
    },
    async update(company: Company) {
        const response = await http.put(`/companies/${company.uuid}`, company);
        return response.data;
    },
    async delete(uuid: string) {
        const response = await http.delete(`/companies/${uuid}`);
        return response.data;
    }
};
